module.exports = __webpack_public_path__ + "static/media/top-nfts-6.6e6df58e.jpg";